/**
 * The Community service's own caps, mirrored so a form can refuse input before a round trip.
 *
 * Three groups rather than one flattened set: DiscussionLimits, FeatureRequestLimits and
 * NotificationLimits all say 100 for MaxTake today, for three unrelated reasons, and collapsing them into
 * one constant is harmless now and wrong the first time one of them moves.
 */

export const DISCUSSION_LIMITS = {
  maxTitleCharacters: 200,
  maxBodyCharacters: 20_000,
  maxExcerptCharacters: 240,
  defaultTake: 20,
  maxTake: 100,
  minQueryCharacters: 2,
  maxQueryCharacters: 200,
  maxQueryWords: 10,
  maxReplies: 200,
  maxMediaUrls: 3,
  maxMediaUrlCharacters: 2_000,
} as const;

export const FEATURE_REQUEST_LIMITS = {
  maxTitleCharacters: 300,
  maxDescriptionCharacters: 10_000,
  maxCommentCharacters: 2_000,
  maxMediaUrls: 3,
  maxMediaUrlCharacters: 2_000,
  defaultTake: 20,
  maxTake: 100,
  minQueryCharacters: 2,
  maxQueryCharacters: 200,
  maxQueryWords: 10,
  maxVoters: 100,
  maxComments: 200,
} as const;

export const NOTIFICATION_LIMITS = {
  maxTargetTitleCharacters: 300,
  maxEndpointCharacters: 2_000,
  maxSubscriptionKeyCharacters: 200,
  maxUserAgentCharacters: 400,
  defaultTake: 20,
  maxTake: 100,
} as const;

export const FEEDBACK_LIMITS = {
  maxTextCharacters: 500,
  maxAttachmentUrls: 3,
  maxAttachmentUrlCharacters: 2_000,
} as const;

/**
 * Upload caps, in bytes. The screenshot and the two media routes share a number and the feedback
 * attachment does not, so they are named per route rather than per size.
 */
export const UPLOAD_LIMITS = {
  maxScreenshotBytes: 10 * 1024 * 1024,
  maxFeedbackAttachmentBytes: 15 * 1024 * 1024,
  maxFeatureRequestMediaBytes: 10 * 1024 * 1024,
  maxDiscussionMediaBytes: 10 * 1024 * 1024,
} as const;

export const RELEASE_SUMMARY_LIMITS = {
  maxSummaryCharacters: 10_000,
} as const;

export const RELEASE_HIGHLIGHT_LIMITS = {
  maxTitleCharacters: 120,
  maxIngressCharacters: 2_000,
  maxUrlCharacters: 2_000,
} as const;

export const SLACK_CLEANUP_LIMITS = {
  defaultHours: 24,
  maxHours: 168,
  defaultLimit: 50,
  maxLimit: 200,
} as const;
